/**
 * @fileoverview gRPC-Web generated client stub for suki.pb.ingester
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.13.0
// source: ingester.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.suki = {};
proto.suki.pb = {};
proto.suki.pb.ingester = require('./ingester_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.suki.pb.ingester.IngesterServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.suki.pb.ingester.IngesterServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.suki.pb.ingester.HealthCheckRequest,
 *   !proto.suki.pb.ingester.HealthCheckResponse>}
 */
const methodDescriptor_IngesterService_HealthCheck = new grpc.web.MethodDescriptor(
  '/suki.pb.ingester.IngesterService/HealthCheck',
  grpc.web.MethodType.UNARY,
  proto.suki.pb.ingester.HealthCheckRequest,
  proto.suki.pb.ingester.HealthCheckResponse,
  /**
   * @param {!proto.suki.pb.ingester.HealthCheckRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.suki.pb.ingester.HealthCheckResponse.deserializeBinary
);


/**
 * @param {!proto.suki.pb.ingester.HealthCheckRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.suki.pb.ingester.HealthCheckResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.suki.pb.ingester.HealthCheckResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.suki.pb.ingester.IngesterServiceClient.prototype.healthCheck =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/HealthCheck',
      request,
      metadata || {},
      methodDescriptor_IngesterService_HealthCheck,
      callback);
};


/**
 * @param {!proto.suki.pb.ingester.HealthCheckRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.suki.pb.ingester.HealthCheckResponse>}
 *     Promise that resolves to the response
 */
proto.suki.pb.ingester.IngesterServicePromiseClient.prototype.healthCheck =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/HealthCheck',
      request,
      metadata || {},
      methodDescriptor_IngesterService_HealthCheck);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.suki.pb.ingester.UpsertIntentsRequest,
 *   !proto.suki.pb.ingester.UpsertIntentsResponse>}
 */
const methodDescriptor_IngesterService_UpsertIntents = new grpc.web.MethodDescriptor(
  '/suki.pb.ingester.IngesterService/UpsertIntents',
  grpc.web.MethodType.UNARY,
  proto.suki.pb.ingester.UpsertIntentsRequest,
  proto.suki.pb.ingester.UpsertIntentsResponse,
  /**
   * @param {!proto.suki.pb.ingester.UpsertIntentsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.suki.pb.ingester.UpsertIntentsResponse.deserializeBinary
);


/**
 * @param {!proto.suki.pb.ingester.UpsertIntentsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.suki.pb.ingester.UpsertIntentsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.suki.pb.ingester.UpsertIntentsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.suki.pb.ingester.IngesterServiceClient.prototype.upsertIntents =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/UpsertIntents',
      request,
      metadata || {},
      methodDescriptor_IngesterService_UpsertIntents,
      callback);
};


/**
 * @param {!proto.suki.pb.ingester.UpsertIntentsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.suki.pb.ingester.UpsertIntentsResponse>}
 *     Promise that resolves to the response
 */
proto.suki.pb.ingester.IngesterServicePromiseClient.prototype.upsertIntents =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/UpsertIntents',
      request,
      metadata || {},
      methodDescriptor_IngesterService_UpsertIntents);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.suki.pb.ingester.UpsertSlotTypesRequest,
 *   !proto.suki.pb.ingester.UpsertSlotTypesResponse>}
 */
const methodDescriptor_IngesterService_UpsertSlotTypes = new grpc.web.MethodDescriptor(
  '/suki.pb.ingester.IngesterService/UpsertSlotTypes',
  grpc.web.MethodType.UNARY,
  proto.suki.pb.ingester.UpsertSlotTypesRequest,
  proto.suki.pb.ingester.UpsertSlotTypesResponse,
  /**
   * @param {!proto.suki.pb.ingester.UpsertSlotTypesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.suki.pb.ingester.UpsertSlotTypesResponse.deserializeBinary
);


/**
 * @param {!proto.suki.pb.ingester.UpsertSlotTypesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.suki.pb.ingester.UpsertSlotTypesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.suki.pb.ingester.UpsertSlotTypesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.suki.pb.ingester.IngesterServiceClient.prototype.upsertSlotTypes =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/UpsertSlotTypes',
      request,
      metadata || {},
      methodDescriptor_IngesterService_UpsertSlotTypes,
      callback);
};


/**
 * @param {!proto.suki.pb.ingester.UpsertSlotTypesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.suki.pb.ingester.UpsertSlotTypesResponse>}
 *     Promise that resolves to the response
 */
proto.suki.pb.ingester.IngesterServicePromiseClient.prototype.upsertSlotTypes =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/UpsertSlotTypes',
      request,
      metadata || {},
      methodDescriptor_IngesterService_UpsertSlotTypes);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.suki.pb.ingester.UpsertSlotValueTypesRequest,
 *   !proto.suki.pb.ingester.UpsertSlotValueTypesResponse>}
 */
const methodDescriptor_IngesterService_UpsertSlotValueTypes = new grpc.web.MethodDescriptor(
  '/suki.pb.ingester.IngesterService/UpsertSlotValueTypes',
  grpc.web.MethodType.UNARY,
  proto.suki.pb.ingester.UpsertSlotValueTypesRequest,
  proto.suki.pb.ingester.UpsertSlotValueTypesResponse,
  /**
   * @param {!proto.suki.pb.ingester.UpsertSlotValueTypesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.suki.pb.ingester.UpsertSlotValueTypesResponse.deserializeBinary
);


/**
 * @param {!proto.suki.pb.ingester.UpsertSlotValueTypesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.suki.pb.ingester.UpsertSlotValueTypesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.suki.pb.ingester.UpsertSlotValueTypesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.suki.pb.ingester.IngesterServiceClient.prototype.upsertSlotValueTypes =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/UpsertSlotValueTypes',
      request,
      metadata || {},
      methodDescriptor_IngesterService_UpsertSlotValueTypes,
      callback);
};


/**
 * @param {!proto.suki.pb.ingester.UpsertSlotValueTypesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.suki.pb.ingester.UpsertSlotValueTypesResponse>}
 *     Promise that resolves to the response
 */
proto.suki.pb.ingester.IngesterServicePromiseClient.prototype.upsertSlotValueTypes =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/UpsertSlotValueTypes',
      request,
      metadata || {},
      methodDescriptor_IngesterService_UpsertSlotValueTypes);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.suki.pb.ingester.GetProjectIdsResponse>}
 */
const methodDescriptor_IngesterService_GetProjectIds = new grpc.web.MethodDescriptor(
  '/suki.pb.ingester.IngesterService/GetProjectIds',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.suki.pb.ingester.GetProjectIdsResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.suki.pb.ingester.GetProjectIdsResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.suki.pb.ingester.GetProjectIdsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.suki.pb.ingester.GetProjectIdsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.suki.pb.ingester.IngesterServiceClient.prototype.getProjectIds =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/GetProjectIds',
      request,
      metadata || {},
      methodDescriptor_IngesterService_GetProjectIds,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.suki.pb.ingester.GetProjectIdsResponse>}
 *     Promise that resolves to the response
 */
proto.suki.pb.ingester.IngesterServicePromiseClient.prototype.getProjectIds =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/GetProjectIds',
      request,
      metadata || {},
      methodDescriptor_IngesterService_GetProjectIds);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.suki.pb.ingester.GetUsersRequest,
 *   !proto.suki.pb.ingester.GetUsersResponse>}
 */
const methodDescriptor_IngesterService_GetUsers = new grpc.web.MethodDescriptor(
  '/suki.pb.ingester.IngesterService/GetUsers',
  grpc.web.MethodType.UNARY,
  proto.suki.pb.ingester.GetUsersRequest,
  proto.suki.pb.ingester.GetUsersResponse,
  /**
   * @param {!proto.suki.pb.ingester.GetUsersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.suki.pb.ingester.GetUsersResponse.deserializeBinary
);


/**
 * @param {!proto.suki.pb.ingester.GetUsersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.suki.pb.ingester.GetUsersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.suki.pb.ingester.GetUsersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.suki.pb.ingester.IngesterServiceClient.prototype.getUsers =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/GetUsers',
      request,
      metadata || {},
      methodDescriptor_IngesterService_GetUsers,
      callback);
};


/**
 * @param {!proto.suki.pb.ingester.GetUsersRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.suki.pb.ingester.GetUsersResponse>}
 *     Promise that resolves to the response
 */
proto.suki.pb.ingester.IngesterServicePromiseClient.prototype.getUsers =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/GetUsers',
      request,
      metadata || {},
      methodDescriptor_IngesterService_GetUsers);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.suki.pb.ingester.GetUsersRequest,
 *   !proto.suki.pb.ingester.GetUsersResponse>}
 */
const methodDescriptor_IngesterService_GetNotNormalizedUsers = new grpc.web.MethodDescriptor(
  '/suki.pb.ingester.IngesterService/GetNotNormalizedUsers',
  grpc.web.MethodType.UNARY,
  proto.suki.pb.ingester.GetUsersRequest,
  proto.suki.pb.ingester.GetUsersResponse,
  /**
   * @param {!proto.suki.pb.ingester.GetUsersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.suki.pb.ingester.GetUsersResponse.deserializeBinary
);


/**
 * @param {!proto.suki.pb.ingester.GetUsersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.suki.pb.ingester.GetUsersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.suki.pb.ingester.GetUsersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.suki.pb.ingester.IngesterServiceClient.prototype.getNotNormalizedUsers =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/GetNotNormalizedUsers',
      request,
      metadata || {},
      methodDescriptor_IngesterService_GetNotNormalizedUsers,
      callback);
};


/**
 * @param {!proto.suki.pb.ingester.GetUsersRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.suki.pb.ingester.GetUsersResponse>}
 *     Promise that resolves to the response
 */
proto.suki.pb.ingester.IngesterServicePromiseClient.prototype.getNotNormalizedUsers =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/GetNotNormalizedUsers',
      request,
      metadata || {},
      methodDescriptor_IngesterService_GetNotNormalizedUsers);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.suki.pb.ingester.UpsertUsersRequest,
 *   !proto.suki.pb.ingester.UpsertUsersResponse>}
 */
const methodDescriptor_IngesterService_UpsertUsers = new grpc.web.MethodDescriptor(
  '/suki.pb.ingester.IngesterService/UpsertUsers',
  grpc.web.MethodType.UNARY,
  proto.suki.pb.ingester.UpsertUsersRequest,
  proto.suki.pb.ingester.UpsertUsersResponse,
  /**
   * @param {!proto.suki.pb.ingester.UpsertUsersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.suki.pb.ingester.UpsertUsersResponse.deserializeBinary
);


/**
 * @param {!proto.suki.pb.ingester.UpsertUsersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.suki.pb.ingester.UpsertUsersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.suki.pb.ingester.UpsertUsersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.suki.pb.ingester.IngesterServiceClient.prototype.upsertUsers =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/UpsertUsers',
      request,
      metadata || {},
      methodDescriptor_IngesterService_UpsertUsers,
      callback);
};


/**
 * @param {!proto.suki.pb.ingester.UpsertUsersRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.suki.pb.ingester.UpsertUsersResponse>}
 *     Promise that resolves to the response
 */
proto.suki.pb.ingester.IngesterServicePromiseClient.prototype.upsertUsers =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/UpsertUsers',
      request,
      metadata || {},
      methodDescriptor_IngesterService_UpsertUsers);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.suki.pb.ingester.GetGroupsRequest,
 *   !proto.suki.pb.ingester.GetGroupsResponse>}
 */
const methodDescriptor_IngesterService_GetGroups = new grpc.web.MethodDescriptor(
  '/suki.pb.ingester.IngesterService/GetGroups',
  grpc.web.MethodType.UNARY,
  proto.suki.pb.ingester.GetGroupsRequest,
  proto.suki.pb.ingester.GetGroupsResponse,
  /**
   * @param {!proto.suki.pb.ingester.GetGroupsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.suki.pb.ingester.GetGroupsResponse.deserializeBinary
);


/**
 * @param {!proto.suki.pb.ingester.GetGroupsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.suki.pb.ingester.GetGroupsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.suki.pb.ingester.GetGroupsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.suki.pb.ingester.IngesterServiceClient.prototype.getGroups =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/GetGroups',
      request,
      metadata || {},
      methodDescriptor_IngesterService_GetGroups,
      callback);
};


/**
 * @param {!proto.suki.pb.ingester.GetGroupsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.suki.pb.ingester.GetGroupsResponse>}
 *     Promise that resolves to the response
 */
proto.suki.pb.ingester.IngesterServicePromiseClient.prototype.getGroups =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/GetGroups',
      request,
      metadata || {},
      methodDescriptor_IngesterService_GetGroups);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.suki.pb.ingester.GetNormalizedGroupsRequest,
 *   !proto.suki.pb.ingester.GetNormalizedGroupsResponse>}
 */
const methodDescriptor_IngesterService_GetNormalizedGroups = new grpc.web.MethodDescriptor(
  '/suki.pb.ingester.IngesterService/GetNormalizedGroups',
  grpc.web.MethodType.UNARY,
  proto.suki.pb.ingester.GetNormalizedGroupsRequest,
  proto.suki.pb.ingester.GetNormalizedGroupsResponse,
  /**
   * @param {!proto.suki.pb.ingester.GetNormalizedGroupsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.suki.pb.ingester.GetNormalizedGroupsResponse.deserializeBinary
);


/**
 * @param {!proto.suki.pb.ingester.GetNormalizedGroupsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.suki.pb.ingester.GetNormalizedGroupsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.suki.pb.ingester.GetNormalizedGroupsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.suki.pb.ingester.IngesterServiceClient.prototype.getNormalizedGroups =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/GetNormalizedGroups',
      request,
      metadata || {},
      methodDescriptor_IngesterService_GetNormalizedGroups,
      callback);
};


/**
 * @param {!proto.suki.pb.ingester.GetNormalizedGroupsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.suki.pb.ingester.GetNormalizedGroupsResponse>}
 *     Promise that resolves to the response
 */
proto.suki.pb.ingester.IngesterServicePromiseClient.prototype.getNormalizedGroups =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/GetNormalizedGroups',
      request,
      metadata || {},
      methodDescriptor_IngesterService_GetNormalizedGroups);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.suki.pb.ingester.GetNotNormalizedGroupsRequest,
 *   !proto.suki.pb.ingester.GetNotNormalizedGroupsResponse>}
 */
const methodDescriptor_IngesterService_GetNotNormalizedGroups = new grpc.web.MethodDescriptor(
  '/suki.pb.ingester.IngesterService/GetNotNormalizedGroups',
  grpc.web.MethodType.UNARY,
  proto.suki.pb.ingester.GetNotNormalizedGroupsRequest,
  proto.suki.pb.ingester.GetNotNormalizedGroupsResponse,
  /**
   * @param {!proto.suki.pb.ingester.GetNotNormalizedGroupsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.suki.pb.ingester.GetNotNormalizedGroupsResponse.deserializeBinary
);


/**
 * @param {!proto.suki.pb.ingester.GetNotNormalizedGroupsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.suki.pb.ingester.GetNotNormalizedGroupsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.suki.pb.ingester.GetNotNormalizedGroupsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.suki.pb.ingester.IngesterServiceClient.prototype.getNotNormalizedGroups =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/GetNotNormalizedGroups',
      request,
      metadata || {},
      methodDescriptor_IngesterService_GetNotNormalizedGroups,
      callback);
};


/**
 * @param {!proto.suki.pb.ingester.GetNotNormalizedGroupsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.suki.pb.ingester.GetNotNormalizedGroupsResponse>}
 *     Promise that resolves to the response
 */
proto.suki.pb.ingester.IngesterServicePromiseClient.prototype.getNotNormalizedGroups =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/GetNotNormalizedGroups',
      request,
      metadata || {},
      methodDescriptor_IngesterService_GetNotNormalizedGroups);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.suki.pb.ingester.UpsertGroupsRequest,
 *   !proto.suki.pb.ingester.UpsertGroupsResponse>}
 */
const methodDescriptor_IngesterService_UpsertGroups = new grpc.web.MethodDescriptor(
  '/suki.pb.ingester.IngesterService/UpsertGroups',
  grpc.web.MethodType.UNARY,
  proto.suki.pb.ingester.UpsertGroupsRequest,
  proto.suki.pb.ingester.UpsertGroupsResponse,
  /**
   * @param {!proto.suki.pb.ingester.UpsertGroupsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.suki.pb.ingester.UpsertGroupsResponse.deserializeBinary
);


/**
 * @param {!proto.suki.pb.ingester.UpsertGroupsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.suki.pb.ingester.UpsertGroupsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.suki.pb.ingester.UpsertGroupsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.suki.pb.ingester.IngesterServiceClient.prototype.upsertGroups =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/UpsertGroups',
      request,
      metadata || {},
      methodDescriptor_IngesterService_UpsertGroups,
      callback);
};


/**
 * @param {!proto.suki.pb.ingester.UpsertGroupsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.suki.pb.ingester.UpsertGroupsResponse>}
 *     Promise that resolves to the response
 */
proto.suki.pb.ingester.IngesterServicePromiseClient.prototype.upsertGroups =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/UpsertGroups',
      request,
      metadata || {},
      methodDescriptor_IngesterService_UpsertGroups);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.suki.pb.ingester.UpsertNormalizedGroupsRequest,
 *   !proto.suki.pb.ingester.UpsertNormalizedGroupsResponse>}
 */
const methodDescriptor_IngesterService_UpsertNormalizedGroups = new grpc.web.MethodDescriptor(
  '/suki.pb.ingester.IngesterService/UpsertNormalizedGroups',
  grpc.web.MethodType.UNARY,
  proto.suki.pb.ingester.UpsertNormalizedGroupsRequest,
  proto.suki.pb.ingester.UpsertNormalizedGroupsResponse,
  /**
   * @param {!proto.suki.pb.ingester.UpsertNormalizedGroupsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.suki.pb.ingester.UpsertNormalizedGroupsResponse.deserializeBinary
);


/**
 * @param {!proto.suki.pb.ingester.UpsertNormalizedGroupsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.suki.pb.ingester.UpsertNormalizedGroupsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.suki.pb.ingester.UpsertNormalizedGroupsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.suki.pb.ingester.IngesterServiceClient.prototype.upsertNormalizedGroups =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/UpsertNormalizedGroups',
      request,
      metadata || {},
      methodDescriptor_IngesterService_UpsertNormalizedGroups,
      callback);
};


/**
 * @param {!proto.suki.pb.ingester.UpsertNormalizedGroupsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.suki.pb.ingester.UpsertNormalizedGroupsResponse>}
 *     Promise that resolves to the response
 */
proto.suki.pb.ingester.IngesterServicePromiseClient.prototype.upsertNormalizedGroups =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/UpsertNormalizedGroups',
      request,
      metadata || {},
      methodDescriptor_IngesterService_UpsertNormalizedGroups);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.suki.pb.ingester.GetFacilitiesRequest,
 *   !proto.suki.pb.ingester.GetFacilitiesResponse>}
 */
const methodDescriptor_IngesterService_GetFacilities = new grpc.web.MethodDescriptor(
  '/suki.pb.ingester.IngesterService/GetFacilities',
  grpc.web.MethodType.UNARY,
  proto.suki.pb.ingester.GetFacilitiesRequest,
  proto.suki.pb.ingester.GetFacilitiesResponse,
  /**
   * @param {!proto.suki.pb.ingester.GetFacilitiesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.suki.pb.ingester.GetFacilitiesResponse.deserializeBinary
);


/**
 * @param {!proto.suki.pb.ingester.GetFacilitiesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.suki.pb.ingester.GetFacilitiesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.suki.pb.ingester.GetFacilitiesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.suki.pb.ingester.IngesterServiceClient.prototype.getFacilities =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/GetFacilities',
      request,
      metadata || {},
      methodDescriptor_IngesterService_GetFacilities,
      callback);
};


/**
 * @param {!proto.suki.pb.ingester.GetFacilitiesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.suki.pb.ingester.GetFacilitiesResponse>}
 *     Promise that resolves to the response
 */
proto.suki.pb.ingester.IngesterServicePromiseClient.prototype.getFacilities =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/GetFacilities',
      request,
      metadata || {},
      methodDescriptor_IngesterService_GetFacilities);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.suki.pb.ingester.UpsertFacilitiesRequest,
 *   !proto.suki.pb.ingester.UpsertFacilitiesResponse>}
 */
const methodDescriptor_IngesterService_UpsertFacilities = new grpc.web.MethodDescriptor(
  '/suki.pb.ingester.IngesterService/UpsertFacilities',
  grpc.web.MethodType.UNARY,
  proto.suki.pb.ingester.UpsertFacilitiesRequest,
  proto.suki.pb.ingester.UpsertFacilitiesResponse,
  /**
   * @param {!proto.suki.pb.ingester.UpsertFacilitiesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.suki.pb.ingester.UpsertFacilitiesResponse.deserializeBinary
);


/**
 * @param {!proto.suki.pb.ingester.UpsertFacilitiesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.suki.pb.ingester.UpsertFacilitiesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.suki.pb.ingester.UpsertFacilitiesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.suki.pb.ingester.IngesterServiceClient.prototype.upsertFacilities =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/UpsertFacilities',
      request,
      metadata || {},
      methodDescriptor_IngesterService_UpsertFacilities,
      callback);
};


/**
 * @param {!proto.suki.pb.ingester.UpsertFacilitiesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.suki.pb.ingester.UpsertFacilitiesResponse>}
 *     Promise that resolves to the response
 */
proto.suki.pb.ingester.IngesterServicePromiseClient.prototype.upsertFacilities =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/UpsertFacilities',
      request,
      metadata || {},
      methodDescriptor_IngesterService_UpsertFacilities);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.suki.pb.ingester.GetContactsRequest,
 *   !proto.suki.pb.ingester.GetContactsResponse>}
 */
const methodDescriptor_IngesterService_GetContacts = new grpc.web.MethodDescriptor(
  '/suki.pb.ingester.IngesterService/GetContacts',
  grpc.web.MethodType.UNARY,
  proto.suki.pb.ingester.GetContactsRequest,
  proto.suki.pb.ingester.GetContactsResponse,
  /**
   * @param {!proto.suki.pb.ingester.GetContactsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.suki.pb.ingester.GetContactsResponse.deserializeBinary
);


/**
 * @param {!proto.suki.pb.ingester.GetContactsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.suki.pb.ingester.GetContactsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.suki.pb.ingester.GetContactsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.suki.pb.ingester.IngesterServiceClient.prototype.getContacts =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/GetContacts',
      request,
      metadata || {},
      methodDescriptor_IngesterService_GetContacts,
      callback);
};


/**
 * @param {!proto.suki.pb.ingester.GetContactsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.suki.pb.ingester.GetContactsResponse>}
 *     Promise that resolves to the response
 */
proto.suki.pb.ingester.IngesterServicePromiseClient.prototype.getContacts =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/GetContacts',
      request,
      metadata || {},
      methodDescriptor_IngesterService_GetContacts);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.suki.pb.ingester.UpsertContactsRequest,
 *   !proto.suki.pb.ingester.UpsertContactsResponse>}
 */
const methodDescriptor_IngesterService_UpsertContacts = new grpc.web.MethodDescriptor(
  '/suki.pb.ingester.IngesterService/UpsertContacts',
  grpc.web.MethodType.UNARY,
  proto.suki.pb.ingester.UpsertContactsRequest,
  proto.suki.pb.ingester.UpsertContactsResponse,
  /**
   * @param {!proto.suki.pb.ingester.UpsertContactsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.suki.pb.ingester.UpsertContactsResponse.deserializeBinary
);


/**
 * @param {!proto.suki.pb.ingester.UpsertContactsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.suki.pb.ingester.UpsertContactsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.suki.pb.ingester.UpsertContactsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.suki.pb.ingester.IngesterServiceClient.prototype.upsertContacts =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/UpsertContacts',
      request,
      metadata || {},
      methodDescriptor_IngesterService_UpsertContacts,
      callback);
};


/**
 * @param {!proto.suki.pb.ingester.UpsertContactsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.suki.pb.ingester.UpsertContactsResponse>}
 *     Promise that resolves to the response
 */
proto.suki.pb.ingester.IngesterServicePromiseClient.prototype.upsertContacts =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/UpsertContacts',
      request,
      metadata || {},
      methodDescriptor_IngesterService_UpsertContacts);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.suki.pb.ingester.GetAPLocationsRequest,
 *   !proto.suki.pb.ingester.GetAPLocationsResponse>}
 */
const methodDescriptor_IngesterService_GetAPLocations = new grpc.web.MethodDescriptor(
  '/suki.pb.ingester.IngesterService/GetAPLocations',
  grpc.web.MethodType.UNARY,
  proto.suki.pb.ingester.GetAPLocationsRequest,
  proto.suki.pb.ingester.GetAPLocationsResponse,
  /**
   * @param {!proto.suki.pb.ingester.GetAPLocationsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.suki.pb.ingester.GetAPLocationsResponse.deserializeBinary
);


/**
 * @param {!proto.suki.pb.ingester.GetAPLocationsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.suki.pb.ingester.GetAPLocationsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.suki.pb.ingester.GetAPLocationsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.suki.pb.ingester.IngesterServiceClient.prototype.getAPLocations =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/GetAPLocations',
      request,
      metadata || {},
      methodDescriptor_IngesterService_GetAPLocations,
      callback);
};


/**
 * @param {!proto.suki.pb.ingester.GetAPLocationsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.suki.pb.ingester.GetAPLocationsResponse>}
 *     Promise that resolves to the response
 */
proto.suki.pb.ingester.IngesterServicePromiseClient.prototype.getAPLocations =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/GetAPLocations',
      request,
      metadata || {},
      methodDescriptor_IngesterService_GetAPLocations);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.suki.pb.ingester.UpsertAPLocationsRequest,
 *   !proto.suki.pb.ingester.UpsertAPLocationsResponse>}
 */
const methodDescriptor_IngesterService_UpsertAPLocations = new grpc.web.MethodDescriptor(
  '/suki.pb.ingester.IngesterService/UpsertAPLocations',
  grpc.web.MethodType.UNARY,
  proto.suki.pb.ingester.UpsertAPLocationsRequest,
  proto.suki.pb.ingester.UpsertAPLocationsResponse,
  /**
   * @param {!proto.suki.pb.ingester.UpsertAPLocationsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.suki.pb.ingester.UpsertAPLocationsResponse.deserializeBinary
);


/**
 * @param {!proto.suki.pb.ingester.UpsertAPLocationsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.suki.pb.ingester.UpsertAPLocationsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.suki.pb.ingester.UpsertAPLocationsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.suki.pb.ingester.IngesterServiceClient.prototype.upsertAPLocations =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/UpsertAPLocations',
      request,
      metadata || {},
      methodDescriptor_IngesterService_UpsertAPLocations,
      callback);
};


/**
 * @param {!proto.suki.pb.ingester.UpsertAPLocationsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.suki.pb.ingester.UpsertAPLocationsResponse>}
 *     Promise that resolves to the response
 */
proto.suki.pb.ingester.IngesterServicePromiseClient.prototype.upsertAPLocations =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/UpsertAPLocations',
      request,
      metadata || {},
      methodDescriptor_IngesterService_UpsertAPLocations);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.suki.pb.ingester.GetVoceraBuddiesRequest,
 *   !proto.suki.pb.ingester.GetVoceraBuddiesResponse>}
 */
const methodDescriptor_IngesterService_GetVoceraBuddies = new grpc.web.MethodDescriptor(
  '/suki.pb.ingester.IngesterService/GetVoceraBuddies',
  grpc.web.MethodType.UNARY,
  proto.suki.pb.ingester.GetVoceraBuddiesRequest,
  proto.suki.pb.ingester.GetVoceraBuddiesResponse,
  /**
   * @param {!proto.suki.pb.ingester.GetVoceraBuddiesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.suki.pb.ingester.GetVoceraBuddiesResponse.deserializeBinary
);


/**
 * @param {!proto.suki.pb.ingester.GetVoceraBuddiesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.suki.pb.ingester.GetVoceraBuddiesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.suki.pb.ingester.GetVoceraBuddiesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.suki.pb.ingester.IngesterServiceClient.prototype.getVoceraBuddies =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/GetVoceraBuddies',
      request,
      metadata || {},
      methodDescriptor_IngesterService_GetVoceraBuddies,
      callback);
};


/**
 * @param {!proto.suki.pb.ingester.GetVoceraBuddiesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.suki.pb.ingester.GetVoceraBuddiesResponse>}
 *     Promise that resolves to the response
 */
proto.suki.pb.ingester.IngesterServicePromiseClient.prototype.getVoceraBuddies =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/GetVoceraBuddies',
      request,
      metadata || {},
      methodDescriptor_IngesterService_GetVoceraBuddies);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.suki.pb.ingester.UpsertVoceraBuddiesRequest,
 *   !proto.suki.pb.ingester.UpsertVoceraBuddiesResponse>}
 */
const methodDescriptor_IngesterService_UpsertVoceraBuddies = new grpc.web.MethodDescriptor(
  '/suki.pb.ingester.IngesterService/UpsertVoceraBuddies',
  grpc.web.MethodType.UNARY,
  proto.suki.pb.ingester.UpsertVoceraBuddiesRequest,
  proto.suki.pb.ingester.UpsertVoceraBuddiesResponse,
  /**
   * @param {!proto.suki.pb.ingester.UpsertVoceraBuddiesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.suki.pb.ingester.UpsertVoceraBuddiesResponse.deserializeBinary
);


/**
 * @param {!proto.suki.pb.ingester.UpsertVoceraBuddiesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.suki.pb.ingester.UpsertVoceraBuddiesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.suki.pb.ingester.UpsertVoceraBuddiesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.suki.pb.ingester.IngesterServiceClient.prototype.upsertVoceraBuddies =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/UpsertVoceraBuddies',
      request,
      metadata || {},
      methodDescriptor_IngesterService_UpsertVoceraBuddies,
      callback);
};


/**
 * @param {!proto.suki.pb.ingester.UpsertVoceraBuddiesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.suki.pb.ingester.UpsertVoceraBuddiesResponse>}
 *     Promise that resolves to the response
 */
proto.suki.pb.ingester.IngesterServicePromiseClient.prototype.upsertVoceraBuddies =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/UpsertVoceraBuddies',
      request,
      metadata || {},
      methodDescriptor_IngesterService_UpsertVoceraBuddies);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.suki.pb.ingester.GetOutsideBuddiesRequest,
 *   !proto.suki.pb.ingester.GetOutsideBuddiesResponse>}
 */
const methodDescriptor_IngesterService_GetOutsideBuddies = new grpc.web.MethodDescriptor(
  '/suki.pb.ingester.IngesterService/GetOutsideBuddies',
  grpc.web.MethodType.UNARY,
  proto.suki.pb.ingester.GetOutsideBuddiesRequest,
  proto.suki.pb.ingester.GetOutsideBuddiesResponse,
  /**
   * @param {!proto.suki.pb.ingester.GetOutsideBuddiesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.suki.pb.ingester.GetOutsideBuddiesResponse.deserializeBinary
);


/**
 * @param {!proto.suki.pb.ingester.GetOutsideBuddiesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.suki.pb.ingester.GetOutsideBuddiesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.suki.pb.ingester.GetOutsideBuddiesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.suki.pb.ingester.IngesterServiceClient.prototype.getOutsideBuddies =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/GetOutsideBuddies',
      request,
      metadata || {},
      methodDescriptor_IngesterService_GetOutsideBuddies,
      callback);
};


/**
 * @param {!proto.suki.pb.ingester.GetOutsideBuddiesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.suki.pb.ingester.GetOutsideBuddiesResponse>}
 *     Promise that resolves to the response
 */
proto.suki.pb.ingester.IngesterServicePromiseClient.prototype.getOutsideBuddies =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/GetOutsideBuddies',
      request,
      metadata || {},
      methodDescriptor_IngesterService_GetOutsideBuddies);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.suki.pb.ingester.UpsertOutsideBuddiesRequest,
 *   !proto.suki.pb.ingester.UpsertOutsideBuddiesResponse>}
 */
const methodDescriptor_IngesterService_UpsertOutsideBuddies = new grpc.web.MethodDescriptor(
  '/suki.pb.ingester.IngesterService/UpsertOutsideBuddies',
  grpc.web.MethodType.UNARY,
  proto.suki.pb.ingester.UpsertOutsideBuddiesRequest,
  proto.suki.pb.ingester.UpsertOutsideBuddiesResponse,
  /**
   * @param {!proto.suki.pb.ingester.UpsertOutsideBuddiesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.suki.pb.ingester.UpsertOutsideBuddiesResponse.deserializeBinary
);


/**
 * @param {!proto.suki.pb.ingester.UpsertOutsideBuddiesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.suki.pb.ingester.UpsertOutsideBuddiesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.suki.pb.ingester.UpsertOutsideBuddiesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.suki.pb.ingester.IngesterServiceClient.prototype.upsertOutsideBuddies =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/UpsertOutsideBuddies',
      request,
      metadata || {},
      methodDescriptor_IngesterService_UpsertOutsideBuddies,
      callback);
};


/**
 * @param {!proto.suki.pb.ingester.UpsertOutsideBuddiesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.suki.pb.ingester.UpsertOutsideBuddiesResponse>}
 *     Promise that resolves to the response
 */
proto.suki.pb.ingester.IngesterServicePromiseClient.prototype.upsertOutsideBuddies =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/UpsertOutsideBuddies',
      request,
      metadata || {},
      methodDescriptor_IngesterService_UpsertOutsideBuddies);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.suki.pb.ingester.DeleteFacilityRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_IngesterService_DeleteFacility = new grpc.web.MethodDescriptor(
  '/suki.pb.ingester.IngesterService/DeleteFacility',
  grpc.web.MethodType.UNARY,
  proto.suki.pb.ingester.DeleteFacilityRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.suki.pb.ingester.DeleteFacilityRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.suki.pb.ingester.DeleteFacilityRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.suki.pb.ingester.IngesterServiceClient.prototype.deleteFacility =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/DeleteFacility',
      request,
      metadata || {},
      methodDescriptor_IngesterService_DeleteFacility,
      callback);
};


/**
 * @param {!proto.suki.pb.ingester.DeleteFacilityRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.suki.pb.ingester.IngesterServicePromiseClient.prototype.deleteFacility =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/DeleteFacility',
      request,
      metadata || {},
      methodDescriptor_IngesterService_DeleteFacility);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.suki.pb.ingester.DeleteGroupRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_IngesterService_DeleteGroup = new grpc.web.MethodDescriptor(
  '/suki.pb.ingester.IngesterService/DeleteGroup',
  grpc.web.MethodType.UNARY,
  proto.suki.pb.ingester.DeleteGroupRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.suki.pb.ingester.DeleteGroupRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.suki.pb.ingester.DeleteGroupRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.suki.pb.ingester.IngesterServiceClient.prototype.deleteGroup =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/DeleteGroup',
      request,
      metadata || {},
      methodDescriptor_IngesterService_DeleteGroup,
      callback);
};


/**
 * @param {!proto.suki.pb.ingester.DeleteGroupRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.suki.pb.ingester.IngesterServicePromiseClient.prototype.deleteGroup =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/DeleteGroup',
      request,
      metadata || {},
      methodDescriptor_IngesterService_DeleteGroup);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.suki.pb.ingester.DeleteUserRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_IngesterService_DeleteUser = new grpc.web.MethodDescriptor(
  '/suki.pb.ingester.IngesterService/DeleteUser',
  grpc.web.MethodType.UNARY,
  proto.suki.pb.ingester.DeleteUserRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.suki.pb.ingester.DeleteUserRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.suki.pb.ingester.DeleteUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.suki.pb.ingester.IngesterServiceClient.prototype.deleteUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/DeleteUser',
      request,
      metadata || {},
      methodDescriptor_IngesterService_DeleteUser,
      callback);
};


/**
 * @param {!proto.suki.pb.ingester.DeleteUserRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.suki.pb.ingester.IngesterServicePromiseClient.prototype.deleteUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/DeleteUser',
      request,
      metadata || {},
      methodDescriptor_IngesterService_DeleteUser);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.suki.pb.ingester.DeleteContactRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_IngesterService_DeleteContact = new grpc.web.MethodDescriptor(
  '/suki.pb.ingester.IngesterService/DeleteContact',
  grpc.web.MethodType.UNARY,
  proto.suki.pb.ingester.DeleteContactRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.suki.pb.ingester.DeleteContactRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.suki.pb.ingester.DeleteContactRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.suki.pb.ingester.IngesterServiceClient.prototype.deleteContact =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/DeleteContact',
      request,
      metadata || {},
      methodDescriptor_IngesterService_DeleteContact,
      callback);
};


/**
 * @param {!proto.suki.pb.ingester.DeleteContactRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.suki.pb.ingester.IngesterServicePromiseClient.prototype.deleteContact =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/DeleteContact',
      request,
      metadata || {},
      methodDescriptor_IngesterService_DeleteContact);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.suki.pb.ingester.DeleteAPLocationRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_IngesterService_DeleteAPLocation = new grpc.web.MethodDescriptor(
  '/suki.pb.ingester.IngesterService/DeleteAPLocation',
  grpc.web.MethodType.UNARY,
  proto.suki.pb.ingester.DeleteAPLocationRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.suki.pb.ingester.DeleteAPLocationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.suki.pb.ingester.DeleteAPLocationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.suki.pb.ingester.IngesterServiceClient.prototype.deleteAPLocation =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/DeleteAPLocation',
      request,
      metadata || {},
      methodDescriptor_IngesterService_DeleteAPLocation,
      callback);
};


/**
 * @param {!proto.suki.pb.ingester.DeleteAPLocationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.suki.pb.ingester.IngesterServicePromiseClient.prototype.deleteAPLocation =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/DeleteAPLocation',
      request,
      metadata || {},
      methodDescriptor_IngesterService_DeleteAPLocation);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.suki.pb.ingester.DeleteVoceraBuddyRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_IngesterService_DeleteVoceraBuddy = new grpc.web.MethodDescriptor(
  '/suki.pb.ingester.IngesterService/DeleteVoceraBuddy',
  grpc.web.MethodType.UNARY,
  proto.suki.pb.ingester.DeleteVoceraBuddyRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.suki.pb.ingester.DeleteVoceraBuddyRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.suki.pb.ingester.DeleteVoceraBuddyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.suki.pb.ingester.IngesterServiceClient.prototype.deleteVoceraBuddy =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/DeleteVoceraBuddy',
      request,
      metadata || {},
      methodDescriptor_IngesterService_DeleteVoceraBuddy,
      callback);
};


/**
 * @param {!proto.suki.pb.ingester.DeleteVoceraBuddyRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.suki.pb.ingester.IngesterServicePromiseClient.prototype.deleteVoceraBuddy =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/DeleteVoceraBuddy',
      request,
      metadata || {},
      methodDescriptor_IngesterService_DeleteVoceraBuddy);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.suki.pb.ingester.DeleteOutsideBuddyRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_IngesterService_DeleteOutsideBuddy = new grpc.web.MethodDescriptor(
  '/suki.pb.ingester.IngesterService/DeleteOutsideBuddy',
  grpc.web.MethodType.UNARY,
  proto.suki.pb.ingester.DeleteOutsideBuddyRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.suki.pb.ingester.DeleteOutsideBuddyRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.suki.pb.ingester.DeleteOutsideBuddyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.suki.pb.ingester.IngesterServiceClient.prototype.deleteOutsideBuddy =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/DeleteOutsideBuddy',
      request,
      metadata || {},
      methodDescriptor_IngesterService_DeleteOutsideBuddy,
      callback);
};


/**
 * @param {!proto.suki.pb.ingester.DeleteOutsideBuddyRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.suki.pb.ingester.IngesterServicePromiseClient.prototype.deleteOutsideBuddy =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/DeleteOutsideBuddy',
      request,
      metadata || {},
      methodDescriptor_IngesterService_DeleteOutsideBuddy);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.suki.pb.ingester.AddAnalyticsTransactionRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_IngesterService_AddAnalyticsTransaction = new grpc.web.MethodDescriptor(
  '/suki.pb.ingester.IngesterService/AddAnalyticsTransaction',
  grpc.web.MethodType.UNARY,
  proto.suki.pb.ingester.AddAnalyticsTransactionRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.suki.pb.ingester.AddAnalyticsTransactionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.suki.pb.ingester.AddAnalyticsTransactionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.suki.pb.ingester.IngesterServiceClient.prototype.addAnalyticsTransaction =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/AddAnalyticsTransaction',
      request,
      metadata || {},
      methodDescriptor_IngesterService_AddAnalyticsTransaction,
      callback);
};


/**
 * @param {!proto.suki.pb.ingester.AddAnalyticsTransactionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.suki.pb.ingester.IngesterServicePromiseClient.prototype.addAnalyticsTransaction =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/AddAnalyticsTransaction',
      request,
      metadata || {},
      methodDescriptor_IngesterService_AddAnalyticsTransaction);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.suki.pb.ingester.GetAnalyticsTransactionsRequest,
 *   !proto.suki.pb.ingester.GetAnalyticsTransactionsResponse>}
 */
const methodDescriptor_IngesterService_GetAnalyticsTransactions = new grpc.web.MethodDescriptor(
  '/suki.pb.ingester.IngesterService/GetAnalyticsTransactions',
  grpc.web.MethodType.UNARY,
  proto.suki.pb.ingester.GetAnalyticsTransactionsRequest,
  proto.suki.pb.ingester.GetAnalyticsTransactionsResponse,
  /**
   * @param {!proto.suki.pb.ingester.GetAnalyticsTransactionsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.suki.pb.ingester.GetAnalyticsTransactionsResponse.deserializeBinary
);


/**
 * @param {!proto.suki.pb.ingester.GetAnalyticsTransactionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.suki.pb.ingester.GetAnalyticsTransactionsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.suki.pb.ingester.GetAnalyticsTransactionsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.suki.pb.ingester.IngesterServiceClient.prototype.getAnalyticsTransactions =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/GetAnalyticsTransactions',
      request,
      metadata || {},
      methodDescriptor_IngesterService_GetAnalyticsTransactions,
      callback);
};


/**
 * @param {!proto.suki.pb.ingester.GetAnalyticsTransactionsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.suki.pb.ingester.GetAnalyticsTransactionsResponse>}
 *     Promise that resolves to the response
 */
proto.suki.pb.ingester.IngesterServicePromiseClient.prototype.getAnalyticsTransactions =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/GetAnalyticsTransactions',
      request,
      metadata || {},
      methodDescriptor_IngesterService_GetAnalyticsTransactions);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.suki.pb.ingester.GetDBMetadataResponse>}
 */
const methodDescriptor_IngesterService_GetDBMetadata = new grpc.web.MethodDescriptor(
  '/suki.pb.ingester.IngesterService/GetDBMetadata',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.suki.pb.ingester.GetDBMetadataResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.suki.pb.ingester.GetDBMetadataResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.suki.pb.ingester.GetDBMetadataResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.suki.pb.ingester.GetDBMetadataResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.suki.pb.ingester.IngesterServiceClient.prototype.getDBMetadata =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/GetDBMetadata',
      request,
      metadata || {},
      methodDescriptor_IngesterService_GetDBMetadata,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.suki.pb.ingester.GetDBMetadataResponse>}
 *     Promise that resolves to the response
 */
proto.suki.pb.ingester.IngesterServicePromiseClient.prototype.getDBMetadata =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/suki.pb.ingester.IngesterService/GetDBMetadata',
      request,
      metadata || {},
      methodDescriptor_IngesterService_GetDBMetadata);
};


module.exports = proto.suki.pb.ingester;

